import { useCallback } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core-react/tracking';

import { useDeferredTrack } from '#src/app/shared/hooks/tracking';

type Result = {
	trackPublicInputClick: () => void;
	trackPublicInputFocus: () => void;
};

export function useTracking(): Result {
	const track = useTrackingBase();
	const deferredTrack = useDeferredTrack();

	return {
		trackPublicInputClick: useCallback(() => {
			deferredTrack('pp_payment_public_optin_clicked');
		}, [deferredTrack]),

		trackPublicInputFocus: useCallback(() => {
			void track('pp_focus_public');
		}, [track]),
	};
}
